// Content for the Expérience numérique hero (site + portail + application mobile).
export type Bi = { fr: string; en: string }

export const DX_IMAGES = {
  town: 'https://cdn.magicpatterns.com/patterns/generated-images/94b18166-5cbc-4e99-b727-71a012be222f.jpg',
  news: 'https://cdn.magicpatterns.com/patterns/generated-images/c5d98b99-dac4-4cc0-85b3-dbbaa89272ac.jpg',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/22b9c3ee-a601-4b7e-a8f6-2f34a01be76c.jpg',
}

export const dxCopy = {
  eyebrow: { fr: 'Expérience numérique', en: 'Digital experience' },
  line1: { fr: 'Votre site. Votre portail.', en: 'Your website. Your portal.' },
  line2: { fr: 'Votre app.', en: 'Your app.' },
  line3: { fr: 'Vos usagers. Enfin connectés.', en: 'Your users. Finally connected.' },
  body: {
    fr: 'Une expérience numérique unifiée qui relie l’information, l’identité, les communications et les services — sur le web, le portail et l’application mobile — et qui peut évoluer avec l’intelligence ATNA.',
    en: 'A unified digital experience that connects information, identity, communications and services — on the web, the portal and the mobile app — and that can evolve with ATNA intelligence.',
  },
  primary: { fr: 'Demander une démo', en: 'Request a demo' },
  secondary: { fr: 'Voir les fonctionnalités', en: 'See the features' },
}

// Shared UI copy inside the three device mockups.
export const dxUi = {
  brand: 'MaVille',
  nav: [
    { fr: 'Services', en: 'Services' },
    { fr: 'Vie municipale', en: 'Municipal life' },
    { fr: 'Loisirs et culture', en: 'Recreation & culture' },
    { fr: 'Environnement', en: 'Environment' },
    { fr: 'Nous joindre', en: 'Contact us' },
  ] as Bi[],
  mySpace: { fr: 'Mon espace', en: 'My Space' },
  question: { fr: 'Qu’avez-vous envie de faire aujourd’hui ?', en: 'What would you like to do today?' },
  ask: { fr: 'Demander à ATNA…', en: 'Ask ATNA…' },
  webActions: [
    { key: 'permit', label: { fr: 'Demander un permis', en: 'Apply for a permit' } },
    { key: 'report', label: { fr: 'Signaler un problème', en: 'Report a problem' } },
    { key: 'bill', label: { fr: 'Payer une facture', en: 'Pay a bill' } },
    { key: 'leisure', label: { fr: 'Activités et loisirs', en: 'Activities & recreation' } },
  ] as { key: 'permit' | 'report' | 'bill' | 'leisure'; label: Bi }[],
  news: { fr: 'Nouvelles', en: 'News' },
  portalNav: [
    { key: 'home', label: { fr: 'Accueil', en: 'Home' } },
    { key: 'requests', label: { fr: 'Mes demandes', en: 'My requests' } },
    { key: 'properties', label: { fr: 'Mes propriétés', en: 'My properties' } },
    { key: 'family', label: { fr: 'Ma famille', en: 'My family' } },
    { key: 'activities', label: { fr: 'Mes activités', en: 'My activities' } },
    { key: 'notifications', label: { fr: 'Mes notifications', en: 'My notifications' } },
    { key: 'bills', label: { fr: 'Mes factures', en: 'My bills' } },
    { key: 'card', label: { fr: 'Ma carte numérique', en: 'My Digital Card' } },
    { key: 'profile', label: { fr: 'Mon profil', en: 'My profile' } },
  ] as { key: 'home' | 'requests' | 'properties' | 'family' | 'activities' | 'notifications' | 'bills' | 'card' | 'profile'; label: Bi }[],
  hello: { fr: 'Bonjour !', en: 'Hello!' },
  helloSub: { fr: 'Vos services, vos propriétés et vos activités.', en: 'Your services, properties and activities.' },
  stats: [
    { value: '3', label: { fr: 'Demandes en cours', en: 'Open requests' } },
    { value: '2', label: { fr: 'Activités inscrites', en: 'Registered activities' } },
  ],
  seeAll: { fr: 'Voir tout', en: 'See all' },
  citizenCard: { fr: 'Ma carte numérique', en: 'My Digital Card' },
  showCard: { fr: 'Afficher ma carte', en: 'Show my card' },
  upcoming: { fr: 'Activités à venir', en: 'Upcoming activities' },
  activities: [
    { title: { fr: 'Hockey mineur', en: 'Minor hockey' }, when: { fr: 'Sam. 12 oct. 10 h', en: 'Sat., Oct. 12, 10 a.m.' } },
    { title: { fr: 'Bain libre', en: 'Public swim' }, when: { fr: 'Dim. 13 oct. 14 h', en: 'Sun., Oct. 13, 2 p.m.' } },
  ],
  phoneActions: [
    { key: 'report', label: { fr: 'Signaler', en: 'Report' } },
    { key: 'permit', label: { fr: 'Demander un permis', en: 'Apply for a permit' } },
    { key: 'card', label: { fr: 'Carte numérique', en: 'Digital Card' } },
    { key: 'leisure', label: { fr: 'Activités', en: 'Activities' } },
  ] as { key: 'report' | 'permit' | 'card' | 'leisure'; label: Bi }[],
  tabs: [
    { key: 'home', label: { fr: 'Accueil', en: 'Home' } },
    { key: 'services', label: { fr: 'Services', en: 'Services' } },
    { key: 'card', label: { fr: 'Carte', en: 'Card' } },
    { key: 'profile', label: { fr: 'Profil', en: 'Profile' } },
  ] as { key: 'home' | 'services' | 'card' | 'profile'; label: Bi }[],
}

export const dxCards = {
  atna: { title: 'ATNA', line1: { fr: 'Je peux vous aider.', en: 'I can help you.' }, line2: { fr: 'Que souhaitez-vous faire ?', en: 'What would you like to do?' } },
  book: { title: { fr: 'Réserver une activité', en: 'Book an activity' }, body: { fr: 'Découvrez les activités près de chez vous.', en: 'Discover activities near you.' } },
  permit: { title: { fr: 'Demander un permis', en: 'Apply for a permit' }, body: { fr: 'Trouvez la bonne démarche en quelques clics.', en: 'Find the right process in a few clicks.' } },
}

export type DxCapabilityKey = 'sso' | 'consent' | 'card' | 'notify' | 'requests'

export const dxCapabilities: { key: DxCapabilityKey; title: Bi; body: Bi }[] = [
  { key: 'sso', title: { fr: 'Identité et SSO', en: 'Identity & SSO' }, body: { fr: 'Un accès unique à vos services.', en: 'One sign-in to all your services.' } },
  { key: 'consent', title: { fr: 'Profil et consentements', en: 'Profile & consents' }, body: { fr: 'Vos informations, sous votre contrôle.', en: 'Your information, under your control.' } },
  { key: 'card', title: { fr: 'Carte numérique', en: 'Digital card' }, body: { fr: 'Vos droits et accès dans une seule carte.', en: 'Your rights and access in one card.' } },
  { key: 'notify', title: { fr: 'Avis et notifications', en: 'Notices & notifications' }, body: { fr: 'Restez informé, au bon moment.', en: 'Stay informed, at the right time.' } },
  { key: 'requests', title: { fr: 'Requêtes et signalements', en: 'Requests & reports' }, body: { fr: 'Signalez un problème et suivez votre demande.', en: 'Report a problem and track your request.' } },
]
